"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUnifiedPunchesQueries = exports.useUnifiedPunches = void 0;
const react_query_1 = require("react-query");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const fetchClient_1 = require("../../client/fetchClient");
const paths_1 = require("../../paths");
const EventEmitter_1 = require("../../utils/EventEmitter");
const luxon_1 = require("luxon");
function useUnifiedPunches({ employeeId, startTimestamp, endTimestamp, timezone, shouldFetch, usageLocation, extendEligibility, countryCode }) {
    const { host, clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const startDateTime = {
        timestamp: startTimestamp,
        timezone: timezone
    };
    const endDateTime = {
        timestamp: endTimestamp,
        timezone: timezone
    };
    const unifiedPunchApiPath = (0, paths_1.GET_UNIFIED_PUNCHES_API)(employeeId, luxon_1.DateTime.fromISO(startTimestamp).toISODate(), luxon_1.DateTime.fromISO(endTimestamp).toISODate(), timezone, extendEligibility, countryCode);
    return (0, react_query_1.useQuery)(['unifiedPunches', unifiedPunchApiPath], () => (0, fetchClient_1.getData)({
        method: 'GET',
        path: unifiedPunchApiPath,
        host,
        eventName: EventEmitter_1.taaEvents.GET_UNIFIED_PUNCHES,
        metaData: {
            apiName: 'getUnifiedPunches',
            clientName
        },
        usageLocation
    }, currentStage), {
        enabled: !!employeeId && !!startDateTime && !!endDateTime && !!shouldFetch,
        staleTime: 60 * 1000,
        retry: false
    });
}
exports.useUnifiedPunches = useUnifiedPunches;
const useUnifiedPunchesQueries = ({ employeeId, startTimestamp, endTimestamp, timezone, shouldFetch, usageLocation, extendEligibility, countryCode }) => {
    const { host, clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const unifiedPunchApiPaths = [];
    const maxEnd = luxon_1.DateTime.fromISO(endTimestamp);
    let start = luxon_1.DateTime.fromISO(startTimestamp);
    let end = getEndDateTime(start.plus({ days: 8 }), maxEnd);
    while (start <= end && start <= maxEnd) {
        unifiedPunchApiPaths.push((0, paths_1.GET_UNIFIED_PUNCHES_API)(employeeId, start.toISODate(), end.toISODate(), timezone, extendEligibility, countryCode));
        start = end.plus({ day: 1 });
        end = getEndDateTime(start.plus({ days: 8 }), maxEnd);
    }
    const mappedQueries = unifiedPunchApiPaths.map((path) => {
        return {
            queryKey: ['unifiedPunches', path],
            queryFn: () => (0, fetchClient_1.getData)({
                method: 'GET',
                path: path,
                host,
                eventName: EventEmitter_1.taaEvents.GET_UNIFIED_PUNCHES,
                metaData: {
                    apiName: 'getUnifiedPunches',
                    clientName
                },
                usageLocation
            }, currentStage),
            enabled: !!employeeId && !!shouldFetch,
            staleTime: 60 * 1000,
            retry: false
        };
    });
    const results = (0, react_query_1.useQueries)(mappedQueries);
    return results;
};
exports.useUnifiedPunchesQueries = useUnifiedPunchesQueries;
const getEndDateTime = (end, maxEnd) => {
    if (end > maxEnd) {
        return maxEnd;
    }
    return end;
};
